/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * zen/v1/thread_service.proto
 * OpenAPI spec version: version not set
 */

/**
 * The rating for the feedback.

 - RATING_UNSPECIFIED: Rating is unspecified.
 - RATING_POSITIVE: Positive feedback.
 - RATING_NEGATIVE: Negative feedback.
 */
export type UserFeedbackMessageRating =
  (typeof UserFeedbackMessageRating)[keyof typeof UserFeedbackMessageRating];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserFeedbackMessageRating = {
  RATING_UNSPECIFIED: 'RATING_UNSPECIFIED',
  RATING_POSITIVE: 'RATING_POSITIVE',
  RATING_NEGATIVE: 'RATING_NEGATIVE',
} as const;
